import type { Campaign } from '@mobi/account/Areas/SignUp'
import { CampaignV2 } from './types'

export const groupBonusBets = (bonusBets: Campaign[]): Record<string, Campaign[]> => {
  return bonusBets.reduce(
    (acc, item) => {
      const groupId = String(item.id)
      if (!acc[groupId]) {
        acc[groupId] = []
      }
      acc[groupId].push(item)
      return acc
    },
    {} as Record<string, Campaign[]>
  )
}

export const isCampaignV2 = (campaign: Campaign | CampaignV2): campaign is CampaignV2 => {
  return (campaign as CampaignV2).tokenCanBeSplit !== undefined
}
